import { render } from "./TabButtonEditor.vue?vue&type=template&id=2e778941&scoped=true"
import script from "./TabButtonEditor.vue?vue&type=script&lang=js"
export * from "./TabButtonEditor.vue?vue&type=script&lang=js"

import "./TabButtonEditor.vue?vue&type=style&index=0&id=2e778941&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e778941"]])

export default __exports__